import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_POST_BY_SLUG = gql`
  query Get($slugName: String!) {
    getPostBySlug(slugName: $slugName) {
      isAuth
      post {
        _id
        postCategory
        postDescription {
          title {
            en
            es
            ca
            pt
          }
          subtitle {
            en
            es
            ca
            pt
          }
          description {
            en
            es
            ca
            pt
          }
          metaTags {
            en
            es
            ca
            pt
          }
          image {
            en
            es
            ca
            pt
          }
          imageSocial {
            en
            es
            ca
            pt
          }
          itemLayout
          tags
          url
          authors{
            name
            slug
          }
          relatedArtists {
            name
            slug
          }
          relatedMagazine {
            title
            slugName
          }
          fallBackUrl
          date
          expirationDate
          launcherSortDate
          cta {
            url
            text {
              en
              ca
              es
              pt
            }
            isDisabled
          }
          overlayImage
          removeBodyChildrenMargin
          loyaltyPoints
          spotifyArtistIds
        }
        active
        noIndex
        scheduledPublishDate
        slugName
        postName
        rolesAllowed
        type
        components
        requiresCompleteRegistration
      }
    }
  }
`;

const getPostBySlug = async (slugName) => {
  try {
    const result = await client
      .query({
        query: GET_POST_BY_SLUG,
        variables: { slugName },
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getPostBySlug: postBySlugData } } = result;

    if (postBySlugData) return postBySlugData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getPostBySlug = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getPostBySlug Error: ${error}`);
    return null;
  }
};

export default getPostBySlug;
